import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "44e94212-cea5-4679-8d44-7648a28ec8d1",
  publicId: "16",
  name: "Electrostatic microphone",
  difficulty: 3,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02, task03],
};

export default lesson;
